import React, { Component } from 'react'
import { connect } from "react-redux"

import {
    css,
    Spinner,
    Button,
    GridCell,
    Grid,
    Icon,
    Theme,
} from "@bdfx/mergado-ui-kit"

import store from "store"
import trans from "trans"
import { AxiosResponse } from "axios"

import { RandomProduct } from "shape-edit/types";
import { getElementValue, getFormName, getTemplateSize } from 'shape-edit/forms/helpers';
import { AlternativeTemplate, Project } from 'app/types/model-types';
import { CollageLayoutType, Template } from "app/types/model-types"
import { setActiveView } from "shape-edit/reducers"
import { postRenderPreviewImage } from "app/helpers/api"

import { createToast } from "actions"
import toastFactory, { textToast } from "app/helpers/toast_factory"
import { POST_RENDER_PREVIEW_IMAGE } from '../reducers';
import { selectFormValues } from 'app/reducers/form';
import { ACTIVE_VIEW_EDIT_QUERIES, ACTIVE_VIEW_EDIT_SOURCE_IMAGE } from 'template-edit/containers/Editor';
import { ID, ReduxList } from 'app/types/app-types';
import { IconDices } from 'app/icons';
import { InpaintingGroupType, WatermarkGroupType } from 'products/types'
import { find } from 'lodash'
import { LevelsModeType } from './save-template-form'
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers'

export interface Props {
    watermarkGroups: ReduxList<WatermarkGroupType[]>
    inpaintingGroups: ReduxList<InpaintingGroupType[]>
    templateId: ID
    altTemplateId: ID
    levels: string[]
    levelsMode: LevelsModeType
    handleImageRefresh: Function
    close: Function
    project: Project
    randomProduct: RandomProduct
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    setActiveView: typeof setActiveView
    collageLayoutsForm: CollageLayoutType[]
    sameImageInPreview: boolean
}

export interface State {
    renderedImageString: string
    isRendering: boolean
}

class PreviewModalWrapper extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            renderedImageString: '',
            isRendering: false,
        }
    }

    componentDidMount(): void {
        this.renderImagePreview()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps && prevProps.randomProduct.id !== this.props.randomProduct.id) {
            this.renderImagePreview()
        }
    }

    renderImagePreview = () => {
        const { isAlt, form, collageLayoutsForm, randomProduct, templateId, altTemplateId, levels, levelsMode, inpaintingGroups, watermarkGroups } = this.props
        const { shapes, collage_layout_id, is_collage, inpainting_group_id, watermark_group_id } = form

        const selectedInpaintingGroup: InpaintingGroupType = find(inpaintingGroups.data, (inpaintingGroup: InpaintingGroupType) => {
            return `${inpaintingGroup?.id}` === `${inpainting_group_id}`
        })

        const selectedWatermarkGroup: WatermarkGroupType = find(watermarkGroups.data, (watermarkGroup: WatermarkGroupType) => {
            return `${watermarkGroup?.id}` === `${watermark_group_id}`
        })

        const templateSize = getTemplateSize()

        const clonedDocument: any = document.documentElement.cloneNode(true);

        //open new popup window:
        // get svg data
        let svg = clonedDocument.querySelector('svg#image');
        svg.setAttribute("width", templateSize.width);
        svg.setAttribute("height", templateSize.height);

        //set opacity to 1 instead of 0.3
        clonedDocument.querySelectorAll('g.draggable-group').forEach((element) => {
            if (element) {
                element.style.opacity = 1;
            }
        });

        //remove dynamic elements
        const dynamicElements = clonedDocument.querySelectorAll('g.dynamic');
        dynamicElements.forEach(function (testElement) {
            if (testElement) {
                testElement.parentNode.removeChild(testElement);
            }
        });

        //remove decorators
        clonedDocument.querySelectorAll('g.draggable-rectangle').forEach(function (element) {
            if (element) {
                element.parentNode.removeChild(element);
            }
        });

        //remove alternative images previews
        clonedDocument.querySelectorAll('g.alternative-image-preview').forEach(function (element) {
            if (element) {
                element.parentNode.removeChild(element);
            }
        });

        //remove preview (we need image data, not just url - cross origin problem)
        clonedDocument.querySelectorAll('image.image-preview').forEach(function (element) {
            if (element) {
                element.parentNode.removeChild(element);
            }
        });

        //remove everything with text:
        //get all parent shapes first
        clonedDocument.querySelectorAll('g.shape').forEach(function (shapeElement) {
            const elementWithText = shapeElement.querySelector('g text')
            if (elementWithText) {
                shapeElement.parentNode.removeChild(shapeElement);
            }
        });

        const background = clonedDocument.querySelector('rect.preview-background');
        if (background) {
            background.parentNode.removeChild(background);
        }

        const svgData = new XMLSerializer().serializeToString(svg);

        // convert svg to png:
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        ctx.canvas.width = templateSize.width;
        ctx.canvas.height = templateSize.height;

        let img = new Image();
        img.setAttribute("src", "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgData))));

        img.onload = () => {
            ctx.drawImage(img, 0, 0);

            //get current collage layout if it is collage:
            const collageLayout = is_collage && collageLayoutsForm && collageLayoutsForm[collage_layout_id] ? collageLayoutsForm[collage_layout_id] : null

            //when image is loaded send request:
            const requestData = {
                shapes: shapes,
                size: templateSize,
                png: canvas.toDataURL("image/png"),
                fields: {
                    ...form,
                    collage_layout: collageLayout,
                    watermark_group: selectedWatermarkGroup,
                    inpainting_group: selectedInpaintingGroup,  //add relations
                    queries: form?.queries,  //alt templates has not queries defined
                },
                randomProduct: this.props.sameImageInPreview ? randomProduct : {}
            }

            this.setState({ isRendering: true })
            postRenderPreviewImage(requestData, templateId, altTemplateId, levels, levelsMode, requestData.fields.queries)
                .then((response: AxiosResponse<any>) => {
                    let img = new Image()

                    if (response.data && response.data.src && response.data.src.length > 0 && response.data.src !== 'data:image/png;base64,') {
                        img.src = response.data.src
                    }

                    img.onload = () => {
                        this.setState({ renderedImageString: img.src })
                    };

                    img.onerror = (evt) => {
                        console.error("Preview Modal: Error while loading image", evt, response.data.src)
                    }
                })
                .catch(error => {
                    console.error('error while rendering preview', error)
                    if (error && error.response && error.response.data) {
                        if (error.response.data.validation_errors) {
                            store.dispatch(createToast(textToast('error', trans(error.response.data.validation_errors))))
                            if (error.response.data.validation_errors['fields.queries']) {
                                this.props.setActiveView(ACTIVE_VIEW_EDIT_QUERIES)
                            } else if (error.response.data.validation_errors['fields.format']) {
                                this.props.setActiveView(ACTIVE_VIEW_EDIT_SOURCE_IMAGE)
                            }
                        } else if (error.response.data.message) {
                            store.dispatch(createToast(textToast('error', trans(error.response.data.message))))
                        }
                    } else {
                        store.dispatch(createToast(toastFactory(POST_RENDER_PREVIEW_IMAGE.ERROR, error)))
                    }
                    this.props.close()
                })
                .finally(() => {
                    this.setState({ isRendering: false })
                })
        };

        img.onerror = (evt) => {
            console.error("error occurred with image", evt)
        }
    }

    render() {
        const { randomProduct, project } = this.props
        const { renderedImageString, isRendering } = this.state
        const { isLoading } = randomProduct
        const item_id = project.e_item_id ? getElementValue(randomProduct.serialized_data, project.e_item_id) : null
        const title = project.e_name ? getElementValue(randomProduct.serialized_data, project.e_name) : null

        return (
            <StyledModalGrid cols={'repeat(3, 1fr)'} gap={'10px'}>
                <GridCell className={'top-buttons'}>
                    {(isLoading || isRendering) ?
                        <span>
                            <Spinner type={"bubbles"} />
                            <span style={{ paddingLeft: '20px' }}>{isLoading ? trans('product_is_loading') : trans('product_is_rendering')}</span>
                        </span>
                        :
                        <Button
                            title={trans('random_product')}
                            type={'void'}
                            color={'nocolor'}
                            secondary={false}
                            icon={<IconDices size={24} color={Theme.blue} />}
                            onClick={() => this.props.handleImageRefresh(true, null)}
                        />
                    }
                </GridCell>
                <GridCell align={'center'} className={'tag'}>
                    <StyledNameTagGrid>
                        {item_id && <GridCell><Icon type={'tag'} text={item_id} title={"ITEM_ID"} /></GridCell>}
                        {title && <GridCell>{title}</GridCell>}
                    </StyledNameTagGrid>
                </GridCell>
                <GridCell />

                <GridCell col={'1/-1'} className={'middle ' + (renderedImageString && isRendering && !isLoading ? 'muk-helper-loading' : '')}>
                    {isLoading || (isRendering && !renderedImageString) &&
                        <Spinner size={80} />
                    }

                    {renderedImageString &&
                        <img id="product-preview" className={'shadow-box checker'} src={renderedImageString} />
                    }
                </GridCell>
            </StyledModalGrid>
        )
    }
}

const StyledNameTagGrid = css(Grid)({
    gridTemplateColumns: 'auto auto',
    gridGap: '40px',
    ' .muk-gridcell': {
        textAlign: 'center',
        alignSelf: 'center',
        whiteSpace: 'nowrap',
    }
})
const StyledModalGrid = css(Grid)({
    margin: '8px',
    " img#product-preview, img.main-image": {
        maxWidth: "100%",
        maxHeight: "calc(100vh - 210px)",
        border: "1px solid #ccc",
    },
    ' .muk-gridcell': {
        textAlign: 'center',
        alignSelf: 'center',
    },
    ' .middle': {
        alignSelf: 'center',
    },
    ' .top': {
        alignSelf: 'start !important',
    },
    ' .bottom': {
        alignSelf: 'end !important',
    },
    ' .stretch': {
        alignSelf: 'stretch !important',
    },
    ' .spinner': {
        paddingBottom: '1em',
    },
    ' .tag': {
        color: '#3a3a3a',
        padding: '0 !important',
        alignSelf: 'start',
    },
    ' .muk-icon--tag': {
        fontSize: 'small',
    },
    ' .padding-top': {
        paddingTop: '40px',
    },
    ' .top-buttons': {
        display: 'grid',
        textAlign: 'left',
        alignSelf: 'start',
        '.muk-spinner--bubbles': {
            height: '20px',
        },
        ' .muk-spinner__wrapper': {
            marginTop: '-22px',
        },
        ' .muk-button': {
            padding: '0 5px',
        },
    },
})

function mapStateToProps(state) {
    return {
        inpaintingGroups: state.inpaintingGroups,
        watermarkGroups: state.watermarkGroups,
        isAlt: state.isAlt,
        alternativeTemplatesLevels: state.alternativeTemplatesLevels,
        form: selectFormValues(state, getFormName(state.isAlt)),
        collageLayoutsForm: selectFormValues(state, 'collageLayoutsForm'),
        sourceImage: state.sourceImage,
        randomProduct: state.randomProduct,
        project: state.project.data,
    }
}

export default connect(mapStateToProps, {
    setActiveView,
})(PreviewModalWrapper)